import { CanActivateFn } from '@angular/router';
import { NotificationService } from '../_services/notification.service';
import { take } from 'rxjs/internal/operators/take';
import { firstValueFrom } from 'rxjs';
import { ProfileService } from '../_services/profile.service';
import { inject } from '@angular/core';

export const notificationGuard: CanActivateFn = async () => {
  const notificationService = inject(NotificationService);
  const profileService = inject(ProfileService);

  const userLogged = await firstValueFrom(profileService.getProfile());
  if (userLogged.result) {
    notificationService
      .unreadedNotifications()
      .pipe(take(1))
      .subscribe(res => {
        notificationService.notification.next([
          res.data.allRequestCount,
          res.data.hobbyRequestCount
        ]);
      });
  }

  return true;
};
